module.exports = __webpack_public_path__ + "static/media/1896px-Razorpay_logo.svg.fcfab237.png";